import { render, staticRenderFns } from "./MostTable.vue?vue&type=template&id=18809259&"
import script from "./MostTable.vue?vue&type=script&lang=js&"
export * from "./MostTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports